
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                    label="Nome do Termo"
                    v-model="form.filters.nome"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-select
                        v-model="form.filters.tipo"
                        label="Tipo"
                        :items="form.lists.tipos"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        dense
                    ></v-select>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.ativo"
                    labelType="Situação"
                ></sigfoco-select-ativo>
            </v-row>
            <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicio"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFim"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
            </v-row>
            <div class="text-center">
                <v-col cols="12">
                <sigfoco-tooltip
                    text="Buscar"
                    icon="mdi-magnify"
                    @click="buscarRelatorios"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                    text="Limpar"
                    icon="mdi-eraser"
                    @click="resetForm"
                ></sigfoco-tooltip>
                </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="headersAnalitico"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            {{ item.tipo }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template class="report" v-slot:[`item.usuarioDaAlteracao`]="{ item }">
            {{ item.usuarioDaAlteracao }}
          </template>
          <template v-slot:[`item.dataHoraAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-termo-log.service"
    import TermoService from '~/services/manter-termo.service';
    export default {
        name: "RelatorioLogTermo",
        mixins: [pageLoadingMixin, RelatorioDeLog, TermoService],
    
        data: () => ({
        onReport: false,
        form: {
            filters: {
                nome: null,
                tipo: null,
                ativo: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                tipos: [],
            },
        },
        headersAnalitico: [
            { text: "Nome do Termo", align: "center", value: "nome" },
            { text: "Tipo", align: "center", value: "tipo" },
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogTermo({ params: this.form.filters });
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { nome, ativo, tipo, dataInicio, dataFim } = this.form.filters;
          if (!nome && ativo == null && tipo == null && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVTermo({ params: this.form.filters });
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeTermoCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFTermo({ params: this.form.filters });
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeTermo.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },

        processarRespostaRelatorio(data) {
            this.form.lists.listRelatorios = data.relatorio.logs;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.nome = null;
          this.form.filters.tipo = null;
          this.form.filters.ativo = null;

          this.form.lists.listRelatorios = [];
        },
        listandoTiposDeTermos() {
            this.$listarTiposDeTermo().then(({ data }) => {
                this.form.lists.tipos = data.lista;
            });
        },
      },
      mounted() {
        this.listandoTiposDeTermos();
    },
};
</script>